var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.25C6.58579 1.25 6.25 1.58579 6.25 2C6.25 2.41421 6.58579 2.75 7 2.75H16.1893L20.25 6.81066V19C20.25 19.4142 20.5858 19.75 21 19.75C21.4142 19.75 21.75 19.4142 21.75 19V6.5C21.75 6.30109 21.671 6.11032 21.5303 5.96967L17.0303 1.46967C16.8897 1.32902 16.6989 1.25 16.5 1.25H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 16C5.74219 15.5858 5.4064 15.25 4.99219 15.25C4.57797 15.25 4.24219 15.5858 4.24219 16V18.25H1.99219C1.57797 18.25 1.24219 18.5858 1.24219 19C1.24219 19.4142 1.57797 19.75 1.99219 19.75H4.24219V22C4.24219 22.4142 4.57797 22.75 4.99219 22.75C5.4064 22.75 5.74219 22.4142 5.74219 22V19.75H7.99219C8.4064 19.75 8.74219 19.4142 8.74219 19C8.74219 18.5858 8.4064 18.25 7.99219 18.25H5.74219V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6.5C2.25 5.25736 3.25736 4.25 4.5 4.25H14.2515C14.6095 4.25 14.9529 4.39223 15.2061 4.64541L18.3546 7.79393C18.6078 8.04711 18.75 8.39049 18.75 8.74853V20.5C18.75 21.7426 17.7426 22.75 16.5 22.75H11C10.5858 22.75 10.25 22.4142 10.25 22C10.25 21.5858 10.5858 21.25 11 21.25H16.5C16.9142 21.25 17.25 20.9142 17.25 20.5V9H14.6C14.2686 9 14 8.73137 14 8.4V5.75H4.5C4.08579 5.75 3.75 6.08579 3.75 6.5V13C3.75 13.4142 3.41421 13.75 3 13.75C2.58579 13.75 2.25 13.4142 2.25 13V6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesAdd);
export default __webpack_public_path__ + "static/media/pages-add.06c42f9e.svg";
export { ForwardRef as ReactComponent };